import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import styles from "./addUser.module.css";

function RegistrationForm() {
  /* ─────────── form fields ─────────── */
  const [driverEmail, setDriverEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [street, setStreet] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [companyId] = useState(localStorage.getItem("admincode") || "");

  /* dropdown lists */
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  /* validation / ui */
  const [formErrors, setFormErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();

  /* ─────────── validators ─────────── */
  const isValidEmail = (email) =>
    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

  const validateForm = () => {
    const errors = {};

    if (!driverEmail.trim()) errors.driverEmail = "Email is required";
    else if (!isValidEmail(driverEmail))
      errors.driverEmail = "Invalid email format";

    if (!loginPassword.trim()) errors.loginPassword = "Password is required";
    if (!confirmPassword.trim())
      errors.confirmPassword = "Confirm Password is required";
    else if (confirmPassword !== loginPassword)
      errors.confirmPassword = "Passwords do not match";

    if (!firstName.trim()) errors.firstName = "First name is required";
    if (!lastName.trim()) errors.lastName = "Last name is required";
    if (!dob.trim()) errors.dob = "Date of birth is required";

    if (!phoneNumber.trim()) errors.phoneNumber = "Phone number is required";
    else if (!/^\d{3}-\d{3}-\d{4}$/.test(phoneNumber))
      errors.phoneNumber = "Invalid phone number (123-456-7890)";

    if (!street.trim()) errors.street = "Street address is required";
    if (!city.trim()) errors.city = "City is required";
    if (!state.trim()) errors.state = "State/Province is required";
    if (!country.trim()) errors.country = "Country is required";
    if (!zipCode.trim()) errors.zipCode = "Zip/Postal Code is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const clearForm = () => {
    setDriverEmail("");
    setLoginPassword("");
    setConfirmPassword("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setDob("");
    setPhoneNumber("");
    setStreet("");
    setCity("");
    setState("");
    setCountry("");
    setZipCode("");
    setFormErrors({});
    setErrorMessage("");
    setSuccessMessage("");
  };

  /* ─────────── phone formatter ─────────── */
  const handlePhoneChange = (e) => {
    let digits = e.target.value.replace(/\D/g, "").substring(0, 10);
    let formatted = digits;
    if (digits.length > 6)
      formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(
        6
      )}`;
    else if (digits.length > 3)
      formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
    setPhoneNumber(formatted);
  };


  const [assessmentData, setAssessmentData] = useState([]);

  const fetchLandingPage = async () => {
    const userCode = localStorage.getItem('reg');
    if (!userCode) {
      console.error('No userCode found in localStorage');
      return;
    }

    try {
      const response = await fetch('https://casaahaanahotels.com/sb_getlandingpage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          usercode: userCode
        })
      });

      const data = await response.json();
      setAssessmentData(data.user_data);
      console.log('Landing page data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching landing page:', error);
      throw error;
    }
  };

  useEffect(() => {
    fetchLandingPage();
  }, [])

  // getting value from assessmentData;
  const {
    adminemail
  } = assessmentData[0] || {};
  localStorage.setItem('adminemail', adminemail);
  /* ─────────── save handler ─────────── */
  // Send email after successful registration
  // const sendEmail = async () => {
  //   const admin_email = localStorage.getItem('adminemail');
  //   const emailAddress = `${driverEmail}`;
  //   const sendmail = `<table border="0" cellpadding="0" cellspacing="0" width="100%">
  //         <tr>
  //         <td align="center">
  //             <table border="0" cellpadding="0" cellspacing="0" width="600">
  //                 <tr>
  //                     <td align="left" valign="middle" width="25%">
  //                         <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" width="136" height="48" alt="Star Behaviors Logo">
  //                     </td>
  //                     <td align="right" width="75%">&nbsp;</td>
  //                 </tr>
  //             </table>
  //         </td>
  //     </tr>
  // </table>

  // <table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#ffffff">
  // <tr>
  //     <td align="center" style="padding: 20px 0;">
  //         <table border="0" cellpadding="0" cellspacing="0" width="600">
  //             <tr>
  //                 <td>
  //                     <p>Dear ${firstName},</p>
  //                     <p>Welcome to the Star Behaviors Behavioral Assessment Platform! We're thrilled to have you on board and excited for the journey ahead.</p>
  //                     <p>Thank you for taking the first step in unlocking your full potential by registering with us. Your decision to join our platform demonstrates your commitment to personal and professional growth, and we're here to support you every step of the way.</p>
  //                     <p>Now that you're officially a part of our community, it's time to dive into the Star Behaviors Behavioral Assessment. This assessment is not just another test; it's a powerful tool designed to help you distinguish yourself from the crowd. By completing the assessment, you'll gain valuable insights into your Qualities, Core Values, and Behaviors – the very traits that set top performers apart from the rest.</p>
  //                     <p>Moreover, this assessment will provide you with additional insights into important aspects such as Job Satisfaction. Understanding your strengths and preferences in the context of job satisfaction can be instrumental in shaping your career path and ensuring fulfillment in your professional endeavors.</p>
  //                     <p>Whether you're aiming to excel in your career, stand out in the job market, or simply gain a deeper understanding of yourself, the Star Behaviors Behavioral Assessment is your key to success. So, don't hesitate – let's embark on this transformative journey together.</p>
  //                     <p>To get started, simply log in to your account and access the assessment section. If you have any questions or need assistance along the way, our dedicated support team is here to help.</p>
  //                     <p>Thank you once again for choosing Star Behaviors. We can't wait to see you shine!</p>
  //                     <p>Warm regards,</p>
  //                     <p>Star Behaviors Assessment Support Team</p>
  //                 </td>
  //             </tr>
  //         </table>
  //     </td>
  // </tr>
  // </table>`;

  //   const newRequestBody = {
  //     email: emailAddress,
  //     name: firstName + " " + lastName,
  //     subject: "Welcome to Star Behaviors Behavioral Assessment Platform!",
  //     message: sendmail,
  //   };

  //   try {
  //     await fetch("https://bakemywords.com/mailchimp/sendmail.php", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       mode: "no-cors",
  //       body: JSON.stringify(newRequestBody),
  //     });
  //     console.log("New email API call sent.");
  //   } catch (err) {
  //     console.error("New email API error:", err);
  //   }
  // };

  const sendEmail = async () => {
    const admin_email = localStorage.getItem('adminemail');
    const recipientEmails = [driverEmail]; // Send to both driver and admin

    const sendmail = `
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <table border="0" cellpadding="0" cellspacing="0" width="600">
            <tr>
              <td align="left" valign="middle" width="25%">
                <img src="https://starbehaviors.com/uploadimage/star_behaviors_llc_cover.jpeg" width="136" height="48" alt="Star Behaviors Logo">
              </td>
              <td align="right" width="75%">&nbsp;</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  
    <table border="0" cellpadding="0" cellspacing="0" width="100%" bgcolor="#ffffff">
      <tr>
        <td align="center" style="padding: 20px 0;">
          <table border="0" cellpadding="0" cellspacing="0" width="600">
            <tr>
              <td>
                <p>Dear ${firstName},</p>
                <p>Welcome to the Star Behaviors Behavioral Assessment Platform! We're thrilled to have you on board and excited for the journey ahead.</p>
                <p>Thank you for taking the first step in unlocking your full potential by registering with us. Your decision to join our platform demonstrates your commitment to personal and professional growth, and we're here to support you every step of the way.</p>
                <p>Now that you're officially a part of our community, it's time to dive into the Star Behaviors Behavioral Assessment. This assessment is not just another test; it's a powerful tool designed to help you distinguish yourself from the crowd. By completing the assessment, you'll gain valuable insights into your Qualities, Core Values, and Behaviors – the very traits that set top performers apart from the rest.</p>
                <p>Moreover, this assessment will provide you with additional insights into important aspects such as Job Satisfaction. Understanding your strengths and preferences in the context of job satisfaction can be instrumental in shaping your career path and ensuring fulfillment in your professional endeavors.</p>
                <p>Whether you're aiming to excel in your career, stand out in the job market, or simply gain a deeper understanding of yourself, the Star Behaviors Behavioral Assessment is your key to success. So, don't hesitate – let's embark on this transformative journey together.</p>
                <p>To get started, simply log in to your account and access the assessment section. If you have any questions or need assistance along the way, our dedicated support team is here to help.</p>
                <p>Thank you once again for choosing Star Behaviors. We can't wait to see you shine!</p>
                <p>Warm regards,</p>
                <p>Star Behaviors Assessment Support Team</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>`;

    const subject = "Welcome to Star Behaviors Behavioral Assessment Platform!";
    const name = `${firstName} ${lastName}`;

    for (const email of recipientEmails) {
      const requestBody = {
        email,
        name,
        subject,
        message: sendmail,
      };

      try {
        await fetch("https://bakemywords.com/mailchimp/sendmail.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "no-cors",
          body: JSON.stringify(requestBody),
        });
        console.log(`Email sent to: ${email}`);
      } catch (err) {
        console.error(`Error sending email to ${email}:`, err);
      }
    }
  };


  const handleSave = async () => {
    if (!validateForm()) return;
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const dataToSend = {
      DriverEmail: driverEmail,
      LoginPassword: loginPassword,
      FirstName: firstName,
      Middle_Name: middleName,
      LastName: lastName,
      dob,
      PhoneNumber: phoneNumber,
      Street: street,
      CurrentCity: city,
      CurrentState: state,
      ZipCode: zipCode,
      companyid: companyId,
    };

    try {
      const resp = await axios.post(
        "https://casaahaanahotels.com/sbdriverregistrations",
        dataToSend,
        { headers: { "Content-Type": "application/json" } }
      );

      if (resp.data?.Message === "Driver registered successfully") {
        sendEmail();
        setSuccessMessage("User added successfully. Redirecting...");
        setTimeout(() => navigate("/user-login"), 1500);
      } else if (
        resp.data?.Message === "Driver with this email already registered"
      ) {
        setErrorMessage("User with this email already exists.");
      } else {
        setErrorMessage(
          "An error occurred while saving the user. Please try again."
        );
      }
    } catch {
      setErrorMessage("An error occurred while saving the user.");
    } finally {
      setLoading(false);
    }
  };

  /* ─────────── fetch state & city ─────────── */
  useEffect(() => {
    if (country) {
      axios
        .post(
          "https://casaahaanahotels.com/ttjstatelist",
          JSON.stringify({ country }),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((res) => setStateList(res.data.result))
        .catch((err) => console.error("State list error:", err));
    } else setStateList([]);
  }, [country]);

  useEffect(() => {
    if (state) {
      axios
        .post(
          "https://casaahaanahotels.com/ttjcitylist",
          JSON.stringify({ country, state }),
          { headers: { "Content-Type": "application/json" } }
        )
        .then((res) => setCityList(res.data.result))
        .catch((err) => console.error("City list error:", err));
    } else setCityList([]);
  }, [state, country]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.card}>
        <h2 className={styles.cardHeader}>Add New User</h2>

        {successMessage && (
          <p className={styles.successMessage}>{successMessage}</p>
        )}
        {errorMessage && (
          <p className={styles.errorMessage}>{errorMessage}</p>
        )}

        <form className={styles.form}>
          {/* Email */}
          <div className={styles.formGroup}>
            <label>User Email*</label>
            <input
              type="email"
              value={driverEmail}
              onChange={(e) => setDriverEmail(e.target.value)}
              className={formErrors.driverEmail ? styles.errorInput : ""}
            />
          </div>

          {/* Password with toggle */}
          <div className={styles.formGroup}>
            <label>Password*</label>
            <div className={styles.passwordWrapper}>
              <input
                type={showPassword ? "text" : "password"}
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                className={formErrors.loginPassword ? styles.errorInput : ""}
              />
              <button
                type="button"
                className={styles.togglePasswordBtn}
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <Icon
                  icon={
                    showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"
                  }
                  inline={true}
                />
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div className={styles.formGroup}>
            <label>Confirm Password*</label>
            <div className={styles.passwordWrapper}>
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={
                  formErrors.confirmPassword ? styles.errorInput : ""
                }
              />
              <button
                type="button"
                className={styles.togglePasswordBtn}
                onClick={() => setShowConfirmPassword((v) => !v)}
                aria-label={showConfirmPassword ? "Hide password" : "Show password"}
              >
                <Icon
                  icon={
                    showConfirmPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"
                  }
                  inline={true}
                />
              </button>
            </div>
          </div>

          {/* First Name */}
          <div className={styles.formGroup}>
            <label>First Name*</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className={formErrors.firstName ? styles.errorInput : ""}
            />
          </div>

          {/* Middle Name */}
          <div className={styles.formGroup}>
            <label>Middle Name</label>
            <input
              type="text"
              value={middleName}
              onChange={(e) => setMiddleName(e.target.value)}
            />
          </div>

          {/* Last Name */}
          <div className={styles.formGroup}>
            <label>Last Name*</label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className={formErrors.lastName ? styles.errorInput : ""}
            />
          </div>

          {/* DOB */}
          <div className={styles.formGroup}>
            <label>Date of Birth*</label>
            <input
              type="date"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              className={formErrors.dob ? styles.errorInput : ""}
            />
          </div>

          {/* Phone */}
          <div className={styles.formGroup}>
            <label>Phone Number (123-456-7890)*</label>
            <input
              type="tel"
              placeholder="123-456-7890"
              value={phoneNumber}
              onChange={handlePhoneChange}
              pattern="\d{3}-\d{3}-\d{4}"
              className={formErrors.phoneNumber ? styles.errorInput : ""}
            />
          </div>

          {/* Street */}
          <div className={styles.formGroup}>
            <label>Street*</label>
            <input
              type="text"
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              className={formErrors.street ? styles.errorInput : ""}
            />
          </div>

          {/* Country */}
          <div className={styles.formGroup}>
            <label>Country*</label>
            <select
              className={styles.formSelect}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            >
              <option value="">Select Country</option>
              <option value="US">United States</option>
              <option value="CA">Canada</option>
            </select>
          </div>

          {/* State/Province */}
          <div className={styles.formGroup}>
            <label>State/Province*</label>
            <select
              className={styles.formSelect}
              value={state}
              onChange={(e) => setState(e.target.value)}
            >
              <option value="">Select State/Province</option>
              {stateList.map((item, i) => (
                <option key={i} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          {/* City */}
          <div className={styles.formGroup}>
            <label>City*</label>
            <input
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className={formErrors.city ? styles.errorInput : ""}
            />
          </div>

          {/* Zip/Postal Code */}
          <div className={styles.formGroup}>
            <label>{country === "US" ? "Zip*" : "Postal Code*"}</label>
            <input
              type={country === "US" ? "number" : "text"}
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              className={formErrors.zipCode ? styles.errorInput : ""}
            />
          </div>

          {/* Buttons */}
          <div className={styles.formActions}>
            <button
              type="button"
              onClick={handleSave}
              className={styles.saveButton}
              disabled={loading}
            >
              {loading ? "Saving..." : "Register"}
            </button>
            <button
              type="button"
              onClick={clearForm}
              className={styles.clearButton}
            >
              Clear Form
            </button>
          </div>
        </form>

        {/* Policies */}
        <ul className="nav nav-pills nav-justified mt-3">
          <li className="nav-item">
            <a
              className="nav-link text-decoration-underline small p-2"
              href="https://sb.starbehaviors.com/imgs/StarBehaviorsPrivacyPolicy.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link text-decoration-underline small p-2"
              href="https://sb.starbehaviors.com/imgs/StarBehaviorsUserAgreement.pdf"
              target="_blank"
              rel="noreferrer"
            >
              User Agreement
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default RegistrationForm;
